var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
// eslint-disable-next-line import/named
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import ErrorDialog from './ErrorDialog';
var Combo = function (_a) {
    var label = _a.label, fetchOptions = _a.fetchOptions, disabled = _a.disabled, setSelectedOptionId = _a.setSelectedOptionId, selectedOptionId = _a.selectedOptionId;
    var _b = useState([]), options = _b[0], setOptions = _b[1];
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(), errorMessage = _e[0], setErrorMessage = _e[1];
    useEffect(function () {
        setLoading(true);
        fetchOptions()
            .then(setOptions)
            .catch(function (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            setErrorMessage("There's been an error fetching options, please check your connection and try again");
        })
            .finally(function () { return setLoading(false); });
    }, [fetchOptions]);
    var handleToggleOpen = function () { return setOpen(!open); };
    var handleOnChange = function (_, option, __) {
        setSelectedOptionId(option === null || option === void 0 ? void 0 : option.id);
    };
    var handleErrorDialogClose = function () { return setErrorMessage(undefined); };
    return (_jsxs(_Fragment, { children: [_jsx(ErrorDialog, { message: errorMessage, onClose: handleErrorDialogClose }), _jsx(Autocomplete, { disabled: disabled || options.length === 0, open: open, onOpen: handleToggleOpen, onClose: handleToggleOpen, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.label; }, options: options, loading: loading, onChange: handleOnChange, value: (selectedOptionId && options.find(function (option) { return option.id === selectedOptionId; })) || null, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: label, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(_Fragment, { children: [loading && _jsx(CircularProgress, { size: 20 }), params.InputProps.endAdornment] })) }) }))); }, renderOption: function (props, option) { return (_createElement("li", __assign({}, props, { key: option.id }), option.label)); } })] }));
};
export default Combo;
